import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
var VideoGif = createComponent({
  displayName: 'VideoGif',
  propTypes: {
    src: PropTypes.string.isRequired,
    width: PropTypes.number
  },
  defaultProps: {
    width: undefined
  },
  render: function render(_ref) {
    var src = _ref.src,
        width = _ref.width;
    return /*#__PURE__*/React.createElement("video", {
      src: src,
      width: width,
      controls: false,
      autoPlay: true,
      loop: true
    });
  }
});
export default VideoGif;
//# sourceMappingURL=video-gif.js.map